import type {EnvironmentField} from '~/models/environmentReport'
import {CONTRACT_TYPE_FOREST_OPERATION, CONTRACT_TYPE_SILVICULTURE_AGREEMENT} from "~/constants/contracts";

export const CONTRACT_TYPES_USING_ENVIRONMENT_REPORT_V2 = [
    CONTRACT_TYPE_SILVICULTURE_AGREEMENT
]

export const CONTRACT_TYPES_WITH_RETENTION_TREES_AFTER_OPERATION_CONSIDERATION = [
    CONTRACT_TYPE_FOREST_OPERATION
]

export const CONTRACT_TYPES_WITH_YOUNG_FOREST_CARE_QUESTION_SECTION = [
    CONTRACT_TYPE_FOREST_OPERATION,
]

export const SW_ENVIRONMENTS = [
  {
    Name: 'NATURE_DB',
    Field: 'NatureDbChecked',
    CommentField: 'NatureDbComments'
  },
  {
    Name: 'CULTURAL_HERITAGE',
    Field: 'CulturalHeritageChecked',
    CommentField: 'CulturalHeritageComments'
  },
  {
    Name: 'SPECIE_DB',
    Field: 'SpecieDbChecked',
    CommentField: 'SpecieDbComments'
  },
  {
    Name: 'WILDLIFE_MAP',
    Field: 'WildlifeMapChecked',
    CommentField: 'WildlifeMapComments'
  },
  {
    Name: 'SELECTED_NATURE',
    Field: 'SelectedNatureChecked',
    CommentField: 'SelectedNatureComments'
  },
  {
    Name: 'KEY_HABITAT',
    Field: 'KeyHabitatChecked',
    CommentField: 'KeyHabitatComments'
  }
]

export const PREPARATORY_FIELDS = [
  {
    Name: 'NATURETYPES_A_AND_B',
    HelpText: 'NATURETYPES_A_AND_B_HELP_TEXT'
  },
  {
    Name: 'DIFFERENT_SPECIES_THREATENED',
    HelpText: 'DIFFERENT_SPECIES_THREATENED_HELP_TEXT'
  },
  {
    Name: 'CULTURAL_HERITAGE_PREP',
    HelpText: 'CULTURAL_HERITAGE_PREP_HELP_TEXT'
  },
  {
    Name: 'PROTECTIVE_FOREST',
    HelpText: 'PROTECTIVE_FOREST_HELP_TEXT'
  },
  {
    Name: 'HIGH_LEVEL_OF_CONFLICT',
    HelpText: 'HIGH_LEVEL_OF_CONFLICT_HELP_TEXT'
  }
]

export const ENVIRONMENTS: EnvironmentField[] = [
  {
    Name: 'NATURE_TYPE_AB',
    CField: 'NatureTypeAbConsideration',
    CComment: 'NatureTypeAbConsiderationComments',
    AField: 'NatureTypeAbAccountedFor',
    AComment: 'NatureTypeAbAccountedForComments',
    HelpText: 'NATURE_TYPE_AB_HELP_TEXT'
  },
  {
    Name: 'PROTECTION_FOREST_FIELD_REGULATIONS',
    CField: 'ProtectionForestFieldRegulationsConsideration',
    CComment: 'ProtectionForestFieldRegulationsConsiderationComments',
    AField: 'ProtectionForestFieldRegulationsAccountedFor',
    AComment: 'ProtectionForestFieldRegulationsAccountedForComments',
    HelpText: 'PROTECTION_FOREST_FIELD_REGULATIONS_HELP_TEXT'
  },
  {
    Name: 'RAPTORS_OWLS_GROUSE_CONSIDERATION',
    CField: 'GrouseRaptornestOtherConsideration',
    CComment: 'GrouseRaptornestOtherConsiderationComments',
    AField: 'GrouseRaptornestOtherAccountedFor',
    AComment: 'GrouseRaptornestOtherAccountedForComments',
    HelpText: 'RAPTORS_OWLS_GROUSE_HELP_TEXT'
  },
  {
    Name: 'KEY_HABITATS_CONSIDERATION',
    CField: 'KeyHabitatsConsideration',
    CComment: 'KeyHabitatsConsiderationComments',
    AField: 'KeyHabitatsAccountedFor',
    AComment: 'KeyHabitatsAccountedForComments',
    HelpText: 'KEY_HABITATS_HELP_TEXT'
  },
  {
    Name: 'CULTURAL_HERITAGE_CONSIDERATION',
    CField: 'CulturalHeritageConsideration',
    CComment: 'CulturalHeritageConsiderationComments',
    AField: 'CulturalHeritageAccountedFor',
    AComment: 'CulturalHeritageAccountedForComments',
    HelpText: 'CULTURAL_HERITAGE_HELP_TEXT'
  },
  {
    Name: 'CARR_SWAMP_DECIDOUS_CONSIDERATION',
    CField: 'CarrSwampDecidousConsideration',
    CComment: 'CarrSwampDecidousConsiderationComments',
    AField: 'CarrSwampDecidousAccountedFor',
    AComment: 'CarrSwampDecidousAccountedForComments',
    HelpText: 'CARR_SWAMP_DECIDOUS_HELP_TEXT'
  },
  {
    Name: 'BUFFERZONES_CONSIDERATION',
    CField: 'BufferzonesConsideration',
    CComment: 'BufferzonesConsiderationComments',
    AField: 'BufferzonesAccountedFor',
    AComment: 'BufferzonesAccountedForComments',
    HelpText: 'BUFFERZONES_HELP_TEXT'
  },
  {
    Name: 'TRAILS_HIKING_DENSE_CONSIDERATION',
    CField: 'TrailsHikingDensePopAreasConsideration',
    CComment: 'TrailsHikingDensePopAreasConsiderationComments',
    AField: 'TrailsHikingDensePopAreasAccountedFor',
    AComment: 'TrailsHikingDensePopAreasAccountedForComments',
    HelpText: 'TRAILS_HIKING_DENSE_HELP_TEXT'
  },
  {
    Name: 'CROSS_STREAMS_RIVERS_CONSIDERATION',
    CField: 'CrossStreamsRiversConsideration',
    CComment: 'CrossStreamsRiversConsiderationComments',
    AField: 'CrossStreamsRiversAccountedFor',
    AComment: 'CrossStreamsRiversAccountedForComments',
    HelpText: 'CROSS_STREAMS_RIVERS_HELP_TEXT'
  },
  {
    Name: 'DRINK_SOURCE_WASTE_CONSIDERATION',
    CField: 'DrinkSourceWasteConsideration',
    CComment: 'DrinkSourceWasteConsiderationComments',
    AField: 'DrinkSourceWasteAccountedFor',
    AComment: 'DrinkSourceWasteAccountedForComments',
    HelpText: 'DRINK_SOURCE_WASTE_HELP_TEXT'
  },
  {
    Name: 'TRACK_DAMAGE_CONSIDERATION',
    CField: null,
    CComment: 'TrackDamageConsiderationComments',
    AField: 'TrackDamageAccountedFor',
    AComment: 'TrackDamageAccountedForComments',
    ANumber: 'TrackDamageAccountedForMeters',
    ANumberHelpText: 'NUMBER_OF_METERS',
    HelpText: 'TRACK_DAMAGE_HELP_TEXT'
  },
  {
    Name: 'OIL_SPILL_CONSIDERATION',
    CField: null,
    AField: 'OilSpillAccountedFor',
    AComment: 'OilSpillAccountedForComments',
    ANumber: 'OilSpillsAccountedForAmount',
    ANumberHelpText: 'NUMBER_OF_LITERS',
    HelpText: 'OIL_SPILL_HELP_TEXT'
  },
  {
    Name: 'RETENTION_TREES_CONSIDERATION',
    CField: null,
    CComment: 'RetentionTreesConsiderationComments',
    AField: 'RetentionTreesAccountedFor',
    AComment: 'RetentionTreesAccountedForComments',
    ANumber: 'RetentionTreesAccountedForAmount',
    ANumberHelpText: 'NUMBER_OF_TREES',
    HelpText: 'RETENTION_TREES_HELP_TEXT'
  },
  // {
  //   Name: 'POWER_LINE_STRIPS_CONSIDERATION',
  //   CField: 'PowerLineStripsConsideration',
  //   CComment: 'PowerLineStripsConsiderationComments',
  //   AField: 'PowerLineStripsAccountedFor',
  //   AComment: 'PowerLineStripsAccountedForComments',
  //   HelpText: 'POWER_LINE_STRIPS_HELP_TEXT'
  // }
]

export const ENVIRONMENT_CONSIDERATIONS_SUPPLY_WOOD: EnvironmentField[] = [
  {
    Name: 'NATURETYPES_A_AND_B',
    CField: 'NatureTypeAbConsideration',
    CComment: 'NatureTypeAbConsiderationComments',
    AField: 'NatureTypeAbAccountedFor',
    AComment: 'NatureTypeAbAccountedForComments',
    HelpText: 'NATURETYPES_A_AND_B_HELP_TEXT',
  },
  {
    Name: 'PROTECTIVE_FOREST',
    CField: 'ProtectionForestFieldRegulationsConsideration',
    CComment: 'ProtectionForestFieldRegulationsConsiderationComments',
    AField: 'ProtectionForestFieldRegulationsAccountedFor',
    AComment: 'ProtectionForestFieldRegulationsAccountedForComments',
    HelpText: 'PROTECTIVE_FOREST_HELP_TEXT',
  },
  {
    Name: 'KEY_HABITATS_CONSIDERATION',
    CField: 'KeyHabitatsConsideration',
    CComment: 'KeyHabitatsConsiderationComments',
    AField: 'KeyHabitatsAccountedFor',
    AComment: 'KeyHabitatsAccountedForComments',
    HelpText: 'KEY_HABITATS_HELP_TEXT',
  },
  {
    Name: 'CULTURAL_HERITAGE_CONSIDERATION',
    CField: 'CulturalHeritageConsideration',
    CComment: 'CulturalHeritageConsiderationComments',
    AField: 'CulturalHeritageAccountedFor',
    AComment: 'CulturalHeritageAccountedForComments',
    HelpText: 'CULTURAL_HERITAGE_HELP_TEXT',
  },
  {
    Name: 'RAPTORS_OWLS_GROUSE_CONSIDERATION',
    CField: 'GrouseRaptornestOtherConsideration',
    CComment: 'GrouseRaptornestOtherConsiderationComments',
    AField: 'GrouseRaptornestOtherAccountedFor',
    AComment: 'GrouseRaptornestOtherAccountedForComments',
    HelpText: 'RAPTORS_OWLS_GROUSE_HELP_TEXT'
  },
]

export const ENVIRONMENT_SELECTION_TYPES_YES = 961700000
export const ENVIRONMENT_SELECTION_TYPES_NO = 961700001
export const ENVIRONMENT_SELECTION_TYPES_NOT_RELEVANT = 961700002

export const ENVIRONMENT_SELECTION_TYPES = [
  {
    Id: ENVIRONMENT_SELECTION_TYPES_YES,
    Name: 'YES'
  },
  {
    Id: 961700001,
    Name: 'NO'
  }
]

export const PLANNING = [
  {
    Name: 'MAIN_ROAD_MARKED_IN_MAP',
    Field: 'MainRoadMarkedInMap',
    CommentField: null
  },
  {
    Name: 'MAIN_ROAD_MARKED_IN_TERRAIN',
    Field: 'MainRoadMarkedInTerrain',
    CommentField: null
  },
  {
    Name: 'BRIDGES_MARKED_IN_MAP',
    Field: 'BridgesMarkedInMap',
    CommentField: null
  },
  {
    Name: 'BRIDGES_MARKED_IN_TERRAIN',
    Field: 'BridgesMarkedInTerrain',
    CommentField: null
  },
  {
    Name: 'POWER_LINE_STRIPS_CONSIDERATION',
    Field: 'PowerLineStrips',
    CommentField: 'PowerLineStripsComments'
  }
]
